<template>
    <v-container
        fluid
        class="pa-6">
        <div class="headline font-weight-bold pb-4">
            {{ $t('saleAgentByPerson.header') }}
        </div>

        <sale-agent-by-person-list-view
            class="saleAgentByPersonListView"
            :saleAgents="orderlist"
            :pagination="pagination"/>

        <v-pagination
            class="pt-2"
            :style="{
                marginRight: '-8px'
            }"
            :value="pagination.page"
            :length="pagination.pageTotal"
            :total-visible="pagination.pageTotalVisible"
            @input="onPaginationChanged"/>
    </v-container>
</template>

<script>// @ts-nocheck

import SaleAgentByPersonListView from '@/views/SaleAgentByPersonListView'
import { mapState } from 'vuex'

export default {
    name: 'SaleAgentByPersonListPage',

    components: {
        SaleAgentByPersonListView
    },

    computed: {
        ...mapState('saleagentByPerson', ['orderlist'])
    },

    data () {
        return {
            saleAgents: [],
            pagination: {
                page: 1,
                pageTotal: 1,
                pageTotalVisible: 1,
                itemsPerPage: 50,
                dateRange: [],
                search: '',
                type: 'ทุกประเภทตัวแทน'
            }
        }
    },

    mounted () {
        this.getSaleAgents()
    },

    methods: {
        getSaleAgents () {
            this.$store.dispatch('saleagentByPerson/fetchOrderlist')
                .then((e) => {
                    this.pagination.pageTotal = e
                    this.pagination.pageTotalVisible = e
                    console.log('this.pagination.pageTotal' + e)
                })
        },

        onPaginationChanged (e) {
            this.pagination.page = e
            this.$store.commit('saleagentByPerson/setPage', e - 1)
            this.$store.dispatch('saleagentByPerson/fetchOrderlist')
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .v-pagination {
    justify-content: right;
    margin-right: -12px;
}
</style>
